
import Socket from 'socket.io-client'

const socketUrl = new URL(config.apiUrl)

// Socket.io initialization
console.log('Connecting to ' + socketUrl.href)

console.log('socketUrl', socketUrl, config.apiUrl)
const socket = Socket(socketUrl.origin, {
  'path':       socketUrl.pathname,
  'transports': ['websocket'],
  // 'timeout': 10000,
  // 'reconnection': true,
  // 'reconnectionDelay': 500,
  // 'reconnectionDelayMax': 5000,
  // 'reconnectionAttempts': Infinity,
})

socket.on('connect', function () {
  console.log('[Socket.io] connected to', socketUrl.href)

  socket.on('disconnect', function () {
    console.log('[Socket.io] disconnected from', socketUrl.href)
  })

  socket.on('close', function () {
    console.log('[Socket.io] closed connection to', socketUrl.href)
  })

  socket.on('reconnect', function () {
    console.log('[Socket.io] Attempting to reconnect to', socketUrl.href)
  })
})

socket.on('connect_failed', function () {
  console.error('[Socket.io] connect_failed')
})

export default socket



// WEBPACK FOOTER //
// ./src/env/apiSocket.js